// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type AffiliateAccountQueryVariables = Types.Exact<{
  customernumber?: Types.InputMaybe<Types.Scalars['String']['input']>;
  customerpin?: Types.InputMaybe<Types.Scalars['String']['input']>;
  ordernumber?: Types.InputMaybe<Types.Scalars['String']['input']>;
  invoicenumber?: Types.InputMaybe<Types.Scalars['String']['input']>;
  packingslipnumber?: Types.InputMaybe<Types.Scalars['String']['input']>;
  quotereferencenumber?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type AffiliateAccountQuery = { __typename?: 'Query', affiliateAccount?: { __typename?: 'AffiliateAccountResponse', soldToAddress: { __typename?: 'AffiliateAccountDetails', customer?: string | null, partnerNumber?: string | null, contactFirstName?: string | null, contactLastName?: string | null, salesOrg?: string | null, organisationName?: string | null, partnerType?: string | null, department?: string | null, buildingRooms?: string | null, houseNumber?: string | null, streetName?: string | null, district?: string | null, cityName?: string | null, country?: string | null, countryName?: string | null, state?: string | null, stateName?: string | null, postalCode?: string | null, language?: string | null, customerAccountGroup?: string | null, customerNumber?: string | null, attention?: string | null, customerAdditionalName?: string | null, street3?: string | null, street4?: string | null, street5?: string | null, poBox?: string | null, telephoneNumber?: string | null, faxNumber?: string | null, street2?: string | null, searchTerm?: string | null }, shipToAddress: { __typename?: 'AffiliateAccountDetails', customer?: string | null, partnerNumber?: string | null, contactFirstName?: string | null, contactLastName?: string | null, salesOrg?: string | null, organisationName?: string | null, partnerType?: string | null, department?: string | null, buildingRooms?: string | null, houseNumber?: string | null, streetName?: string | null, district?: string | null, cityName?: string | null, country?: string | null, countryName?: string | null, state?: string | null, stateName?: string | null, postalCode?: string | null, language?: string | null, customerAccountGroup?: string | null, customerNumber?: string | null, attention?: string | null, customerAdditionalName?: string | null, street3?: string | null, street4?: string | null, street5?: string | null, poBox?: string | null, telephoneNumber?: string | null, faxNumber?: string | null, street2?: string | null, searchTerm?: string | null }, billToAddress: { __typename?: 'AffiliateAccountDetails', customer?: string | null, partnerNumber?: string | null, contactFirstName?: string | null, contactLastName?: string | null, salesOrg?: string | null, organisationName?: string | null, partnerType?: string | null, department?: string | null, buildingRooms?: string | null, houseNumber?: string | null, streetName?: string | null, district?: string | null, cityName?: string | null, country?: string | null, countryName?: string | null, state?: string | null, stateName?: string | null, postalCode?: string | null, language?: string | null, customerAccountGroup?: string | null, customerNumber?: string | null, attention?: string | null, customerAdditionalName?: string | null, street3?: string | null, street4?: string | null, street5?: string | null, poBox?: string | null, telephoneNumber?: string | null, faxNumber?: string | null, street2?: string | null, searchTerm?: string | null }, payerAddress: { __typename?: 'AffiliateAccountDetails', customer?: string | null, partnerNumber?: string | null, contactFirstName?: string | null, contactLastName?: string | null, salesOrg?: string | null, organisationName?: string | null, partnerType?: string | null, department?: string | null, buildingRooms?: string | null, houseNumber?: string | null, streetName?: string | null, district?: string | null, cityName?: string | null, country?: string | null, countryName?: string | null, state?: string | null, stateName?: string | null, postalCode?: string | null, language?: string | null, customerAccountGroup?: string | null, customerNumber?: string | null, attention?: string | null, customerAdditionalName?: string | null, street3?: string | null, street4?: string | null, street5?: string | null, poBox?: string | null, telephoneNumber?: string | null, faxNumber?: string | null, street2?: string | null, searchTerm?: string | null } } | null };

export type AffiliateAccountDetailsFragmentFragment = { __typename?: 'AffiliateAccountDetails', customer?: string | null, partnerNumber?: string | null, contactFirstName?: string | null, contactLastName?: string | null, salesOrg?: string | null, organisationName?: string | null, partnerType?: string | null, department?: string | null, buildingRooms?: string | null, houseNumber?: string | null, streetName?: string | null, district?: string | null, cityName?: string | null, country?: string | null, countryName?: string | null, state?: string | null, stateName?: string | null, postalCode?: string | null, language?: string | null, customerAccountGroup?: string | null, customerNumber?: string | null, attention?: string | null, customerAdditionalName?: string | null, street3?: string | null, street4?: string | null, street5?: string | null, poBox?: string | null, telephoneNumber?: string | null, faxNumber?: string | null, street2?: string | null, searchTerm?: string | null };

export const AffiliateAccountDetailsFragmentFragmentDoc = gql`
    fragment AffiliateAccountDetailsFragment on AffiliateAccountDetails {
  customer
  partnerNumber
  contactFirstName
  contactLastName
  salesOrg
  organisationName
  partnerType
  department
  buildingRooms
  houseNumber
  streetName
  district
  cityName
  country
  countryName
  state
  stateName
  postalCode
  language
  customerAccountGroup
  customerNumber
  attention
  customerAdditionalName
  street3
  street4
  street5
  poBox
  telephoneNumber
  faxNumber
  street2
  searchTerm
}
    `;
export const AffiliateAccountDocument = gql`
    query AffiliateAccount($customernumber: String, $customerpin: String, $ordernumber: String, $invoicenumber: String, $packingslipnumber: String, $quotereferencenumber: String) {
  affiliateAccount(
    customernumber: $customernumber
    customerpin: $customerpin
    ordernumber: $ordernumber
    invoicenumber: $invoicenumber
    packingslipnumber: $packingslipnumber
    quotereferencenumber: $quotereferencenumber
  ) {
    soldToAddress {
      ...AffiliateAccountDetailsFragment
    }
    shipToAddress {
      ...AffiliateAccountDetailsFragment
    }
    billToAddress {
      ...AffiliateAccountDetailsFragment
    }
    payerAddress {
      ...AffiliateAccountDetailsFragment
    }
  }
}
    ${AffiliateAccountDetailsFragmentFragmentDoc}`;
export type AffiliateAccountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AffiliateAccountQuery, AffiliateAccountQueryVariables>, 'query'>;

    export const AffiliateAccountComponent = (props: AffiliateAccountComponentProps) => (
      <ApolloReactComponents.Query<AffiliateAccountQuery, AffiliateAccountQueryVariables> query={AffiliateAccountDocument} {...props} />
    );
    

/**
 * __useAffiliateAccountQuery__
 *
 * To run a query within a React component, call `useAffiliateAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliateAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliateAccountQuery({
 *   variables: {
 *      customernumber: // value for 'customernumber'
 *      customerpin: // value for 'customerpin'
 *      ordernumber: // value for 'ordernumber'
 *      invoicenumber: // value for 'invoicenumber'
 *      packingslipnumber: // value for 'packingslipnumber'
 *      quotereferencenumber: // value for 'quotereferencenumber'
 *   },
 * });
 */
export function useAffiliateAccountQuery(baseOptions?: Apollo.QueryHookOptions<AffiliateAccountQuery, AffiliateAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliateAccountQuery, AffiliateAccountQueryVariables>(AffiliateAccountDocument, options);
      }
export function useAffiliateAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliateAccountQuery, AffiliateAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliateAccountQuery, AffiliateAccountQueryVariables>(AffiliateAccountDocument, options);
        }
export function useAffiliateAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliateAccountQuery, AffiliateAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AffiliateAccountQuery, AffiliateAccountQueryVariables>(AffiliateAccountDocument, options);
        }
export type AffiliateAccountQueryHookResult = ReturnType<typeof useAffiliateAccountQuery>;
export type AffiliateAccountLazyQueryHookResult = ReturnType<typeof useAffiliateAccountLazyQuery>;
export type AffiliateAccountSuspenseQueryHookResult = ReturnType<typeof useAffiliateAccountSuspenseQuery>;
export type AffiliateAccountQueryResult = Apollo.QueryResult<AffiliateAccountQuery, AffiliateAccountQueryVariables>;